import isobject from 'isobject';
import PropTypes from 'prop-types';
import { createElement, useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { useDevice } from '@atc/react-device';
import { useClientOnly } from '@atc/react-client-only';
function LazyRender(_ref) {
  let {
    componentClass: Component = 'div',
    componentProps,
    style,
    height,
    children,
    enableIdleRender = false,
    threshold = 300,
    fallback = [],
    width,
    forceRender = false,
    ...rest
  } = _ref;
  const [idle, setIdle] = useState(false);
  const isClient = useClientOnly();
  const device = useDevice();
  const [ref, inView] = useInView({
    rootMargin: `${threshold}px 0px`,
    triggerOnce: true
  });
  useEffect(() => {
    let callbackId;
    if (enableIdleRender) {
      const idleCallback = () => setIdle(true);
      callbackId = window.requestIdleCallback && window.requestIdleCallback(idleCallback);
    }
    return () => callbackId && window.cancelIdleCallback && window.cancelIdleCallback(callbackId);
  }, [enableIdleRender]);
  const markerStyle = {
    ...style
  };
  if (height) {
    if (isobject(height)) {
      markerStyle.height = height[device.mediaType];
    } else {
      markerStyle.height = height;
    }
  }
  if (width) {
    if (isobject(width)) {
      markerStyle.width = width[device.mediaType];
    } else {
      markerStyle.width = width;
    }
  }
  const LazyRenderMarker = /*#__PURE__*/createElement(Component, {
    ref,
    style: markerStyle,
    ...componentProps,
    ...rest
  }, fallback);
  return isClient && (inView || idle) || forceRender ? children : LazyRenderMarker;
}
export default LazyRender;